const de = {
  submit: 'Speichern',
  cancel: 'Abbrechen',
  email: 'Email',
  name: 'Name',
  lists: 'Listen',
}
export default de;